/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkAssignReviewerRequest
 */
export interface BulkAssignReviewerRequest {
    /**
     * 
     * @type {string}
     * @memberof BulkAssignReviewerRequest
     */
    userId: string;
}

/**
 * Check if a given object implements the BulkAssignReviewerRequest interface.
 */
export function instanceOfBulkAssignReviewerRequest(value: object): value is BulkAssignReviewerRequest {
    if ((!('userId' in (value as Record<string, any>)) && !('user_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['userId'] === undefined && (value as Record<string, any>)['user_id'] === undefined)) return false;
    return true;
}

export function BulkAssignReviewerRequestFromJSON(json: any): BulkAssignReviewerRequest {
    return BulkAssignReviewerRequestFromJSONTyped(json, false);
}

export function BulkAssignReviewerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkAssignReviewerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
    };
}

export function BulkAssignReviewerRequestToJSON(json: any): BulkAssignReviewerRequest {
    return BulkAssignReviewerRequestToJSONTyped(json, false);
}

export function BulkAssignReviewerRequestToJSONTyped(value?: BulkAssignReviewerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
    };
}

